import { serializeArrayToUrlParams } from './serialization-functions.model';

export interface RdsBaseParameters {
  /** Response format */
  format?: string;
  groupBy?: Array<string>;
  /** Whether to inject code labels */
  inject?: boolean;
  /** Number of rows to query */
  limit?: number;
  /** Whether to include metadata */
  metadata?: boolean;
  /** Row number to start at */
  offset?: number;
  /**
   * Sort order for the query.
   * @example
   * orderBy=STATE ASC,AGE DESC
   */
  orderBy?: string;
}

export function serializeBaseUrlParam(prop: string, value: any): string {
  switch (prop) {
    case 'groupBy':
      return serializeArrayToUrlParams(prop, value);
    default:
      return !prop || value === null || value === 'undefined' ? '' : `${prop}=${encodeURIComponent(value)}&`;
  }
}
